import { useEffect, useRef } from "react";
import styles from "./ComplianceProgressBar.module.scss";

type ComplianceProgressBarProps = {
  progress: number;
};

export function ComplianceProgressBar({
  progress,
}: ComplianceProgressBarProps) {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (rootRef.current) {
      rootRef.current.style.setProperty(
        "--bar-width",
        `${clampedProgress + 4}%`
      );
    }
  }, [clampedProgress]);

  return (
    <div ref={rootRef} className={styles.root} data-progress={clampedProgress}>
      <div className={styles.barOutline}>
        <div className={styles.bar} />
      </div>
      <p className={styles.label}>{clampedProgress}%</p>
    </div>
  );
}
